<template>
  <mastery-modal
    :name="modalName"
    type="masteryModalWhite"
    :header-image="headerImage"
    :max-width="372"
    :primary-action-text="primaryText"
    button-variant="danger"
    :secondary-action-text="secondaryText"
    @before-open="beforeOpen"
    @close-fn="handleModalClose"
    @primary-action-clicked="expirePurchaseReceipt"
    @secondary-action-clicked="handleSecondaryAction"
  >
    <div
      v-if="catalogPage"
      class="post-questionnaire"
    >
      <p class="addon-title">
        {{ stripHtml(catalogPage.removeConfig.title || '') }}
      </p>
      <p class="addon-description">
        {{ stripHtml(catalogPage.removeConfig.description || '') }}
      </p>
    </div>
  </mastery-modal>
</template>

<script>
import MasteryModal from '@/components/ui/masteryModal.vue';

import { stripHtml } from '@/utils';

export default {
  name: 'CatalogRemoveModal',
  components: { MasteryModal },
  data() {
    return {
      catalogPage: null,
      source: null,
    };
  },
  computed: {
    headerImage() {
      const attachmentId = this.catalogPage?.removeConfig.iconId;
      if (attachmentId) {
        return this.$store.getters['attachments/get'][attachmentId];
      }
    },
    modalName() {
      return 'catalog-remove-modal';
    },
    primaryText() {
      return this.catalogPage?.removeConfig.affirmativeButtonText;
    },
    secondaryText() {
      return this.catalogPage?.removeConfig.negativeButtonText;
    },
  },
  methods: {
    beforeOpen(event) {
      if (event?.params) {
        this.catalogPage = event.params.catalogPage;
        this.source = event.params.source;
      }
    },
    closeModal() {
      this.$modal.hide(this.modalName);
    },
    expirePurchaseReceipt() {
      this.sendAnalytics(this.primaryText);
      const freePO = this.$store.getters['purchaseOrders/addon'].find(
        (po) => po.parentId === this.catalogPage?.purchaseOrderId && po.isFree,
      );
      if (freePO) {
        const receipt = this.$store.getters['purchaseReceipts/all'].find(
          (pr) => pr.purchaseOrderId === freePO.id && !pr.expiresAt,
        );
        if (receipt) {
          this.$store
            .dispatch('purchaseReceipts/expire', { id: receipt.id })
            .then(() => this.closeModal());
        }
      }
    },
    handleModalClose() {
      this.catalogPage = null;
      this.source = null;
    },
    handleSecondaryAction() {
      this.closeModal();
      this.sendAnalytics(this.secondaryText);
    },
    sendAnalytics(answer) {
      this.$analytics.events.disabledAddOn(this.catalogPage, this.source, answer);
    },
    stripHtml,
  },
};
</script>

<style lang="scss" scoped>
/deep/ .header-image {
  width: 30%;
}

.post-questionnaire {
  .addon-title,
  .addon-description {
    margin: 0;
    padding: 0;
  }

  .addon-title {
    font-weight: $bold;
    font-size: rem-calc(26);
  }

  .addon-description {
    line-height: 1.5;
  }
}
</style>
